import React from 'react';

interface ElementorIconProps {
  className?: string;
}

export default function ElementorIcon({ className = "h-4 w-4" }: ElementorIconProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink" 
      version="1.1" 
      id="Capa_1" 
      viewBox="0 0 24 24" 
      style={{ enableBackground: 'new 0 0 24 24' }} 
      xmlSpace="preserve" 
      width="512" 
      height="512"
      className={className}
    >
      <g>
        <path 
          fill="currentColor"
          d="M12.003,0C5.376-0.001,0.001,5.37,0,11.997C-0.001,18.624,5.37,23.999,11.997,24C18.624,24.001,23.999,18.63,24,12.003V12   C24,5.374,18.629,0.001,12.003,0z M9.001,16.999h-2v-10h2V16.999z M17.002,16.999h-6v-2h6V16.999z M17.002,12.998h-6v-2h6V12.998z    M17.002,8.999h-6v-2h6V8.999z"
        />
      </g>
    </svg>
  );
}